export enum ScreenType {
    Dashboard = 1,
}
